import React from 'react';
import { Link } from 'react-router-dom';

const socialLinks = [
  { img: '/facebook.png', label: 'Facebook', href: 'https://facebook.com' },
  { img: '/instagram.jpg', label: 'Instagram', href: 'https://instagram.com' },
  { img: '/youtube.png', label: 'YouTube', href: 'https://youtube.com' },
];

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer style={{ background: '#1f2937', color: '#e5e7eb', paddingTop: '60px' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 24px' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '40px', paddingBottom: '48px' }}>

          {/* Brand */}
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '16px' }}>
              <div style={{
                width: '40px', height: '40px', borderRadius: '50%',
                background: 'linear-gradient(135deg, #C2185B, #AD1457)',
                display: 'flex', alignItems: 'center', justifyContent: 'center', 
fontSize: '9px',color: 'white',
      fontFamily: 'Agbalumo',
      fontWeight: 'bold',
          }}>
            weddyfyp</div>
              <span style={{ fontFamily: "'Playfair Display', serif", fontSize: '22px', fontWeight: '700', color: '#fff' }}>
                Weddyfyp matrimony
              </span>
            </div>
            <p style={{ fontSize: '14px', color: '#9ca3af', lineHeight: '1.7', marginBottom: '16px' }}>
              A growing force in India's matrimonial sector, established with a vision to make the search for a life partner seamless and joyful.
            </p>
            <p style={{ fontSize: '13px', color: '#6b7280', fontStyle: 'italic', marginBottom: '20px', paddingBottom: '16px', borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
              This website is strictly for matrimonial purpose only and not a dating website.
            </p>
            <div style={{ display: 'flex', gap: '12px' }}>
              {socialLinks.map(s => (
                <a key={s.label} href={s.href} target="_blank" rel="noreferrer"
                  title={s.label}
                  style={{
                    width: '38px', height: '38px', borderRadius: '8px',
                    background: 'rgba(255,255,255,0.08)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    transition: 'background 0.2s', cursor: 'pointer', overflow: 'hidden',
                  }}
                  onMouseEnter={e => e.currentTarget.style.background = 'rgba(194,24,91,0.5)'}
                  onMouseLeave={e => e.currentTarget.style.background = 'rgba(255,255,255,0.08)'}
                >
                  <img src={s.img} alt={s.label} style={{ width: '24px', height: '24px', objectFit: 'contain' }} />
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 style={{ color: '#fff', fontSize: '16px', fontWeight: '600', marginBottom: '16px', fontFamily: "'Playfair Display', serif" }}>
              Quick Links
            </h4>
            {[
              { label: 'Home', path: '/' },
              { label: 'About Us', path: '/about' },
              { label: 'Contact Us', path: '/contact' },
            ].map(link => (
              <Link key={link.path} to={link.path} style={{
                display: 'block', color: '#9ca3af', fontSize: '14px',
                marginBottom: '10px', transition: 'color 0.2s',
              }}
                onMouseEnter={e => e.target.style.color = '#f48fb1'}
                onMouseLeave={e => e.target.style.color = '#9ca3af'}
              >
                → {link.label}
              </Link>
            ))}
          </div>

          {/* Legal */}
          <div>
            <h4 style={{ color: '#fff', fontSize: '16px', fontWeight: '600', marginBottom: '16px', fontFamily: "'Playfair Display', serif" }}>
              Legal
            </h4>
            {[
              { label: 'Terms & Conditions', path: '/terms' },
              { label: 'Privacy Policy', path: '/privacy' },
              { label: 'Delete Account', path: '/delete-account' },
            ].map(link => (
              <Link key={link.path} to={link.path} style={{
                display: 'block', color: '#9ca3af', fontSize: '14px',
                marginBottom: '10px', transition: 'color 0.2s',
              }}
                onMouseEnter={e => e.target.style.color = '#f48fb1'}
                onMouseLeave={e => e.target.style.color = '#9ca3af'}
              >
                → {link.label}
              </Link>
            ))}
          </div>

          {/* Contact */}
          <div>
            <h4 style={{ color: '#fff', fontSize: '16px', fontWeight: '600', marginBottom: '16px', fontFamily: "'Playfair Display', serif" }}>
              Contact Us
            </h4>
            {[
              { icon: '📧', text: 'info@weddyfyp.com' },
              { icon: '📞', text: '+91 9490023820' },
              { icon: '📍', text: 'A/P P NO 11 & 12, 206, SRI S RESIDENCY, OLD BOWENPALLY, HYDERABAD 500011' },
              { icon: '🕐', text: 'Mon–Sat: 9 AM – 6 PM IST' },
            ].map((item, i) => (
              <div key={i} style={{ display: 'flex', gap: '10px', marginBottom: '12px', alignItems: 'flex-start' }}>
                <span style={{ fontSize: '15px', marginTop: '2px', flexShrink: 0 }}>{item.icon}</span>
                <span style={{ color: '#9ca3af', fontSize: '13px', lineHeight: '1.6' }}>{item.text}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Bottom bar */}
        <div style={{
          borderTop: '1px solid rgba(255,255,255,0.08)',
          padding: '20px 0',
          display: 'flex', flexWrap: 'wrap', gap: '12px',
          alignItems: 'center', justifyContent: 'space-between',
        }}>
          <div>
            <p style={{ fontSize: '13px', color: '#6b7280' }}>
              © {year} Weddyfyp. All rights reserved.
            </p>
            <p style={{ fontSize: '12px', color: '#4b5563', marginTop: '4px' }}>
              Powered By <span style={{ color: '#9ca3af' }}>Roald Software Solution Pvt Ltd</span>
            </p>
          </div>
          <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
            {[
              { label: 'Terms', path: '/terms' },
              { label: 'Privacy', path: '/privacy' },
              { label: 'Delete Account', path: '/delete-account' },
            ].map(link => (
              <Link key={link.path} to={link.path} style={{
                fontSize: '13px', color: '#6b7280', transition: 'color 0.2s',
              }}
                onMouseEnter={e => e.target.style.color = '#f48fb1'}
                onMouseLeave={e => e.target.style.color = '#6b7280'}
              >
                {link.label}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
